import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="logo-icon">{'🎓'}</span>
              <span className="logo-text"> MTC </span>
              <span className="logo-subtitle">School</span>
            </div>
            <p className="footer-tagline">
              Nurturing Minds, Building Futures. Providing quality education
              with expert faculty. Satellite Town, Mirpurkhas.
            </p>
          </div>
          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#programs">Programs</a></li>
              <li><a href="#features">Facilities</a></li>
              <li><a href="#testimonials">Testimonials</a></li>
              <li><a href="#enroll">Enroll</a></li>
            </ul>
          </div>
          <div className="footer-links">
            <h4>Programs</h4>
            <ul>
              <li><a href="#programs">Primary School</a></li>
              <li><a href="#programs">Middle School</a></li>
              <li><a href="#programs">High School</a></li>
              <li><a href="#programs">Science Stream</a></li>
              <li><a href="#programs">Commerce Stream</a></li>
              <li><a href="#programs">Arts & Humanities</a></li>
            </ul>
          </div>
          <div className="footer-newsletter">
            <h4>Stay Updated</h4>
            <p>Subscribe to our newsletter for news and updates.</p>
            <form className="newsletter-form" onSubmit={(e) => e.preventDefault()}>
              <input type="email" placeholder="Enter your email" required />
              <button type="submit" className="btn btn-gold">Subscribe</button>
            </form>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} MTC School. All Rights Reserved.</p>
            <div className="footer-bottom-links">
              <a href="#">Privacy Policy</a>
              <a href="#">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
